import _extends from "@babel/runtime/helpers/extends";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import classNames from 'classnames/bind';
import { AnimatePresence, motion } from 'framer-motion';
import { headerMetric } from "../../../../../../metric";
import { MenuUrlTarget } from "../../../../../../types";
import { NavigationItem } from "./NavigationItem";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var fadeVariants = {
  initial: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.3,
      ease: 'easeInOut'
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
      ease: 'easeInOut'
    }
  }
};
export var NavigationLinksContainer = function NavigationLinksContainer(_ref) {
  var tabs = _ref.tabs,
    activeTab = _ref.activeTab,
    activeCategory = _ref.activeCategory,
    _onHover = _ref.onHover;
  return /*#__PURE__*/React.createElement(AnimatePresence, {
    mode: "wait"
  }, /*#__PURE__*/React.createElement(motion.div, {
    animate: "visible",
    className: cx('navigation'),
    exit: "exit",
    initial: "initial",
    key: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.title,
    variants: fadeVariants
  }, tabs === null || tabs === void 0 ? void 0 : tabs.map(function (item, index) {
    return /*#__PURE__*/React.createElement(NavigationItem, _extends({
      index: index,
      isActive: (activeTab === null || activeTab === void 0 ? void 0 : activeTab.title) === item.title,
      item: item,
      key: item.title,
      onHover: function onHover() {
        if (typeof window !== 'undefined' && window.ym) {
          headerMetric.handleNavTabClick(JSON.stringify({
            tab: item.title,
            section: activeCategory.title
          }));
        }
        if (!item.url) _onHover === null || _onHover === void 0 ? void 0 : _onHover(item);
      }
    }, item.url && {
      href: item.url,
      target: MenuUrlTarget.get(item.isBlankUrlTarget)
    }));
  })));
};